export enum VisibilityToggleType {
  BAR = 'bar',
  ICON = 'icon',
}

export interface VisibilityToggleProps {
  visible: boolean;
  onChange: (visible: boolean) => void;
  tooltipTitle: string;
  type?: VisibilityToggleType;
}
